import { Component, OnInit, OnDestroy } from '@angular/core';
import { faSliders, faAngleDown, faAngleUp, faSpinner, faClockRotateLeft, faEdit, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { MessageService } from 'src/app/share/sharedsubject';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import dayjs from 'dayjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RangeDatePickerComponent } from 'src/app/share/range-date-picker/range-date-picker.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { MessageModalComponent } from 'src/app/share/components/message-modal/message-modal.component';
import { EditReasonModalComponent } from 'src/app/share/components/edit-reason-modal/edit-reason-modal.component';


@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.scss'],
    standalone: false
})

export class OrderListComponent implements OnInit, OnDestroy {
  private readonly searchSubject$ = new Subject<void>();
  private searchSubscription!: Subscription;
  private stockOutSub?: Subscription;

  protected readonly faSliders = faSliders;
  protected readonly faAngleDown = faAngleDown;
  protected readonly faAngleUp = faAngleUp;
  protected readonly faSpinner = faSpinner;
  protected readonly faClockRotateLeft = faClockRotateLeft;
  protected readonly faEdit = faEdit;
  protected readonly faInfoCircle = faInfoCircle;

  stockOutData: any[] = [];
  loader: boolean = false;
  exportLoading: boolean = false;
  showExportList: boolean = false;
  errorMessage: any;
  filters: any = { page: 0 };
  filtersForm = {
    branch: [] as string[],
    tyreSize: '',
    tyreMake: '',
    tyreModel: '',
    stockOutType: [] as string[],
    paymentMode: [] as string[],
    created_datefrom: '',
    created_dateupto: ''
  };
  showFilterPanel: boolean = false;
  displayRangeText: string = 'All';
  dateRanges: any[] = [
    { label: 'All', value: 'all' },
    { label: 'Today', value: 1 },
    { label: 'Last 7 Days', value: 7 },
    { label: 'Last 30 Days', value: 30 },
    { label: 'Last 90 Days', value: 90 }
  ];
  paymentModeList = [
    { name: 'Cash', value: 'Cash' },
    { name: 'Bank Transfer', value: 'BankTransfer' },
    { name: 'UPI', value: 'UPI' },
    { name: 'Card', value: 'Card' },
    { name: 'Credit', value: 'Credit' },
    { name: 'Bajaj Finance', value: 'BajajFinance' }
  ];
  stockOutTypeList = [
    { name: 'Import from sheet', value: 'ImportFromSheet' },
    { name: 'Replace to customer', value: 'ReplaceToCustomer' },
    { name: 'Return to dealer', value: 'ReturnToDealer' },
    { name: 'Sold to customer', value: 'SoldToCustomer' },
    { name: 'Sold to dealer', value: 'SoldToDealer' },
    { name: 'Transfer to branch', value: 'TransferToBranch' },
    { name: 'Service', value: 'hasService' }
  ];

  isBranchVisible: boolean = false;
  companyData: any[] = [];
  endOfResults: boolean = false;
  tosterMsg: string = '';
  message: any;
  subscription: Subscription;
  selectedVocher: { url: any, name: any } = { url: '', name: '' };

  constructor(
    private readonly stockService: StockService,
    private readonly companyService: CompanyServiceService,
    private readonly messageService: MessageService,
    private readonly modalService: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly router: Router,
    private readonly storageService: StorageService,
  ) {
    this.subscription = this.messageService.getMessage().subscribe((message: any) => {
      if (message) {
        this.message = message.text;
        this.openMessageModal();
      }
    });
    let userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
        this.isBranchVisible = userDetailsData?.enrollmentType === 'Company';
        if (this.isBranchVisible) {
          this.getAllBranchList();
        }
  }

  ngOnInit() {
    this.searchSubscription = this.searchSubject$.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.onChangeApplyFilter();
    });

    this.getAllStockOutDetails();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getAllBranchList() {
    this.loader = true;
    this.companyService.getToCompanyList().subscribe({
      next: (res: any) => {
        this.loader = false;
        this.companyData = (res.data || []).filter((company: any) => company.status === 'Active');
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message;
        this.loader = false;
      }
    });
  }

  getAllStockOutDetails() {
    this.loader = true;
    this.stockOutSub = this.stockService.getAllStockOutList(this.filters).subscribe({
      next: (res: any) => {
        const newData = (res.data || []).map((order: any) => this.processOrder(order));
        this.stockOutData = this.stockOutData.concat(newData);
        if (res.data.length === 0) {
          this.endOfResults = true;
        }
        this.loader = false;
      },
      error: (error: any) => {
        this.errorMessage = error?.error?.error?.message;
        this.loader = false;
      }
    });
  }

  buildEditReason(stock: any[], reason: string): string {
    const lines: string[] = [];
    (stock || []).forEach((s: any) => {
      const identity = [s.tyreSize, s.tyreMake, s.tyreModel].filter(Boolean).join(' ');
      if (s.editedQuantity !== undefined && s.editedQuantity !== null) {
        lines.push(`${identity}, quantity changed from ${s.quantity} to ${s.editedQuantity}`);
      }
      if (s.editedtyresAmount !== undefined && s.editedtyresAmount !== null) {
        lines.push(`${identity}, price changed from ${s.tyresAmount} to ${s.editedtyresAmount}`);
      }
    });
    if (reason) lines.push(`With reason: ${reason}`);
    return lines.join('\n');
  }

  processOrder(order: any) {
    order.branchName = order.company?.name || '-';
    order.partnerName = order.customerId?.customerName || order.dealer?.name || order.toBranch?.name || '';

    if (order.paymentAccounts?.length) {
      const modes = order.paymentAccounts.map((pa: any) => pa.mode).filter(Boolean);
      if (modes.length) {
        order.paymentMode = modes.map((m: string) => {
          if (m === 'BankTransfer') return 'Bank Transfer';
          if (m === 'BajajFinance') return 'Bajaj Finance';
          return m;
        }).join(', ');
      }
    }

    const stockItems = (order.stock || []).map((s: any) => {
      s.finalQuantity = s.editedQuantity ?? s.quantity ?? null;
      s.finalUnitPrice = s.editedtyresAmount ?? s.tyresAmount ?? null;
      s.value = (s.finalUnitPrice === null || s.finalQuantity === null) ? null : s.finalQuantity * s.finalUnitPrice;
      return { ...s, itemType: 'stock' };
    });

    const serviceItems = (order.service || [])
      .filter((s: any) => s.value !== undefined && s.value !== null && s.value !== '')
      .map((s: any) => {
        s.finalQuantity = null;
        s.finalUnitPrice = null;
        return { ...s, itemType: 'service' };
      });

    order.allRows = [...stockItems, ...serviceItems];
    order.stockCount = stockItems.length;
    order.serviceCount = serviceItems.length;
    order.totalRows = order.allRows.length;
    const type = (order.stockOutType || '').toLowerCase();
    const canEditBase = (['soldtocustomer', 'soldtodealer', 'transfertobranch'].includes(type) && stockItems.length !== 0);
    order.hasEditAction = canEditBase;
    order.fullReason = canEditBase ? this.buildEditReason(order.stock, order.reason) : '';
    
    const isTxToday = this.isToday(order.created);
    const hasReturnedStock = Array.isArray(order.returnedStock) && order.returnedStock.length > 0;

    if (hasReturnedStock) {
      order.canEdit = false;
    } else if (this.isBranchVisible) {
      order.canEdit = canEditBase;
    } else {
      order.canEdit = canEditBase && isTxToday;
    }

    order.buttonTooltip = this.getOrderButtonTooltip(canEditBase, order.fullReason, isTxToday, hasReturnedStock);
    order.badgeClass = this.getOrderBadgeClass(type);

    if (order.created) {
      const createdDate = new Date(order.created);
      order.formattedDateStr = createdDate.toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      order.formattedTimeStr = createdDate.toLocaleTimeString('en-GB', {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).toUpperCase();
      order.formattedCreated = `${order.formattedDateStr} ${order.formattedTimeStr}`;
    }

    return order;
  }

  onScroll() {
    if (this.endOfResults || this.loader) return;
    this.filters.page++;
    this.getAllStockOutDetails();
  }

  buildActiveFilters(): any {
    const activeFilters: any = Object.fromEntries(
      Object.entries(this.filtersForm).filter(([_, value]) => {
        if (Array.isArray(value)) return value.length > 0;
        return value !== '' && value !== null && value !== 'all';
      })
    );

    if (activeFilters.stockOutType && Array.isArray(activeFilters.stockOutType)) {
      const hasServiceSelected = activeFilters.stockOutType.includes('hasService');
      const otherTypes = activeFilters.stockOutType.filter((type: string) => type !== 'hasService');
      if (hasServiceSelected) activeFilters.hasService = true;
      if (otherTypes.length > 0) activeFilters.stockOutType_in = otherTypes.toString();
      delete activeFilters.stockOutType;
    }

    if (activeFilters.paymentMode && Array.isArray(activeFilters.paymentMode)) {
      activeFilters.paymentMode_in = activeFilters.paymentMode.toString();
      delete activeFilters.paymentMode;
    }

    if (activeFilters.branch && Array.isArray(activeFilters.branch)) {
      activeFilters.branch_in = activeFilters.branch.toString();
      delete activeFilters.branch;
    }

    return activeFilters;
  }

  onTextInputChange() {
    this.searchSubject$.next();
  }

  onChangeApplyFilter() {
    this.endOfResults = false;
    if (this.stockOutSub) {
      this.stockOutSub.unsubscribe();
    }
    this.stockOutData = [];
    this.filters = { page: 0, ...this.buildActiveFilters() };
    this.getAllStockOutDetails();
  }

  applyDaysRange(days: any) {
    if (days === 'all') {
      this.filtersForm.created_datefrom = '';
      this.filtersForm.created_dateupto = '';
      this.displayRangeText = 'All';
    } else {
      const today = dayjs();
      const start = today.subtract(days - 1, 'day');
      this.filtersForm.created_datefrom = start.format('YYYY-MM-DD');
      this.filtersForm.created_dateupto = today.format('YYYY-MM-DD');
      if (days === 1) this.displayRangeText = 'Today';
      else if (days === 7) this.displayRangeText = 'Last 7 Days';
      else if (days === 30) this.displayRangeText = 'Last 30 Days';
      else if (days === 90) this.displayRangeText = 'Last 90 Days';
    }
    this.onChangeApplyFilter();
  }

  openCalendar() {
    const modalRef = this.modalService.open(RangeDatePickerComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.initialFromDate = this.filtersForm.created_datefrom;
    modalRef.componentInstance.initialToDate = this.filtersForm.created_dateupto;

    modalRef.result.then((result) => {
      if (result?.fromDate && result?.toDate) {
        this.filtersForm.created_datefrom = result.fromDate;
        this.filtersForm.created_dateupto = result.toDate;
        this.displayRangeText = dayjs(result.fromDate).format('DD-MM-YYYY') + ' - ' + dayjs(result.toDate).format('DD-MM-YYYY');
        this.onChangeApplyFilter();
      }
    }, () => { });
  }

  openFilterPanel() {
    this.showFilterPanel = !this.showFilterPanel;
  }

  get isExportEnabled(): boolean {
    return !!(this.filtersForm.created_datefrom && this.filtersForm.created_dateupto);
  }

  exportList() {
    if (!this.isExportEnabled) return;
    this.exportLoading = true;

    const payload = { ...this.buildActiveFilters() };

    this.stockService.exportstockOutList(payload).subscribe({
      next: () => {
        this.tosterMsg = 'Sales list is successfully exported';
        this.exportLoading = false;
        this.showExportList = true;
      },
      error: (error: any) => {
        this.tosterMsg = error?.error?.message || 'Something went wrong while exporting';
        this.exportLoading = false;
      }
    });
  }

  viewVoucher(data: any, model: any) {
    const invoiceUrl = (data.replacedInvoice && data.isEdited) ? data.replacedInvoice : data.invoice;
    if (invoiceUrl) {
      this.selectedVocher.url = this.sanitizer.bypassSecurityTrustResourceUrl(invoiceUrl);
      this.selectedVocher.name = (data.replacedInvoiceNumber && data.isEdited ) ? data.replacedInvoiceNumber : data.invoiceNumber;
      this.modalService.open(model, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    }
  }

  editTransaction(order: any) {
    const type = (order.stockOutType || '').toLowerCase();
    if (!order._id) return
    if (type == 'soldtocustomer') {
      this.router.navigate(['order-out'], {
        queryParams: {
          id: order._id,
        }
      })
    } else if (type == 'soldtodealer') {
      this.router.navigate(['sale-to-dealer'], {
        queryParams: {
          id: order._id,
        }
      })
    } else if (type == 'transfertobranch') {
      this.router.navigate(['transfer-to-branch'], {
        queryParams: {
          id: order._id,
        }
      })
    }
  }

  trackById(index: number, item: any) {
    return item ? item._id : index;
  }

  isToday(dateStr: any): boolean {
    if (!dateStr) return false;
    try {
      const dateVal = new Date(dateStr);
      if (Number.isNaN(dateVal.getTime())) return false;
      const orderDateStr = dateVal.toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      const todayDateStr = new Date().toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      return orderDateStr === todayDateStr;
    } catch (error) {
      const _ = error;
      return false;
    }
  }

  openReasonModal(order: any) {
    const modalRef = this.modalService.open(EditReasonModalComponent, { centered: true, size: 'md' });
    modalRef.componentInstance.fullReason = order.fullReason;
  }

  openMessageModal() {
    const modalRef = this.modalService.open(MessageModalComponent, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });
    modalRef.componentInstance.message = this.message;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.stockOutSub) {
      this.stockOutSub.unsubscribe();
    }
  }

  closeToster(event: any) {
    this.tosterMsg = '';
  }

  private getOrderButtonTooltip(canEditBase: boolean, fullReason: string, isTxToday: boolean, hasReturnedStock: boolean): string {
    if (!canEditBase) return '';
    if (fullReason) return "Transaction edited. Click to view edit reason";
    if (hasReturnedStock) return "This invoice is returned/exchanged and cannot be edited";
    if (!this.isBranchVisible && !isTxToday) return "Branch users can only edit today's transactions";
    return "Edit Transaction";
  }

  private getOrderBadgeClass(type: string): string {
    if (type.includes('transfer')) return 'bg-transfer';
    if (['soldtocustomer', 'soldtodealer', 'returntodealer'].includes(type)) return 'bg-sale';
    if (type.includes('import')) return 'bg-purchase';
    if (type.includes('adjustment')) return 'bg-adjustment';
    return 'bg-sale';
  }
}
